import React from 'react';
import { fieldLabelStyle, fieldStyle, textareaStyle } from '../DevPanel.style';

interface IMockJsonFieldProps {
    label: string;
    testId: string;
    value: string;
    onChange: (value: string) => void;
}

export const MockJsonField = ({
    label,
    testId,
    value,
    onChange,
}: IMockJsonFieldProps): React.ReactElement => (
    <label style={fieldStyle}>
        <span style={fieldLabelStyle}>{label}</span>
        <textarea
            data-testid={testId}
            placeholder="JSON goes here"
            rows={5}
            value={value}
            style={textareaStyle}
            onChange={(event) => onChange(event.target.value)}
        />
    </label>
);
